import { graphql } from 'react-relay';
import { isEmpty } from 'ramda';

import { commit } from '../../mutations/commit';

const updateCashbackMutation = graphql`
  mutation updateCashbackMutation($input: UpdateCashbackInput!) {
    updateCashback(input: $input) {
      cashback {
        id
      }
      errorMessage
      errors {
        key
        messages
      }
    }
  }
`;

const updateCashbackAndReloadFastCashMutation = graphql`
  mutation updateCashbackAndReloadFastCashMutation(
    $input: UpdateCashbackInput!
    $byAuth0Id: String!
    $afterDate: Date!
    $beforeDate: Date!
    $bankAccountIdEq: String!
    $stateEq: String
    $storeIdEq: String
    $integrationItemIdEq: Int
    $nameCont: String
    $byMerchantNames: String
    $nameNotIContAll: String
  ) {
    updateCashback(input: $input) {
      cashback {
        id
        date
        storeId
        place
        amount
        ...CashbackCell_cashback
      }
      fastCash(byAuth0Id: $byAuth0Id) {
        ...FastCashContainer_fastCash
      }
      errorMessage
      errors {
        key
        messages
      }
    }
  }
`;

const formMutationParams = (params, args) => {
  const {
    id,
    place,
    storeId,
    date,
    afterDate,
    beforeDate,
    byAuth0Id,
    stateEq,
    bankAccountIdEq,
    storeIdEq,
    integrationItemIdEq,
    nameCont,
    byMerchantNames,
    nameNotIContAll,
  } = params;
  const inputParams = { id, place, storeId, date };

  if (isEmpty(byAuth0Id)) {
    return {
      mutation: updateCashbackMutation,
      variables: {
        input: inputParams,
      },
      ...args,
    };
  }

  return {
    mutation: updateCashbackAndReloadFastCashMutation,
    variables: {
      input: inputParams,
      afterDate,
      beforeDate,
      byAuth0Id,
      bankAccountIdEq,
      stateEq,
      storeIdEq,
      integrationItemIdEq,
      nameCont,
      byMerchantNames,
      nameNotIContAll,
    },
    ...args,
  };
};

const UpdateCashback = (environment, params, args = {}) => {
  const mutationParams = formMutationParams(params, args);

  return commit(environment, mutationParams);
};

export default UpdateCashback;
